// This file was generated with `npm run icons:generate`. Don’t edit directly.
import Icon from 'tailwind/components/Icon/Icon';
import type { MediumIconProps } from 'tailwind/components/Icon/Icon.types';

const UtilityStrokeNotificationMediumIcon = (props: MediumIconProps) => (
  <Icon {...props} viewBox="0 0 32 32">
    <path
      d="M16.0003 5.79171C12.5486 5.79171 9.75033 8.58994 9.75033 12.0417V18.4457C9.75033 19.1574 9.41303 19.8655 8.78361 20.1978C8.12116 20.5476 7.66699 21.2442 7.66699 22.0417C7.66699 23.1875 8.60449 24.125 9.75033 24.125H22.2503C23.3962 24.125 24.3337 23.1875 24.3337 22.0417C24.3337 21.2442 23.8795 20.5476 23.217 20.1978C22.5876 19.8655 22.2503 19.1574 22.2503 18.4457V12.0417C22.2503 8.58994 19.4521 5.79171 16.0003 5.79171ZM16.0003 5.79171V3.70837M13.917 28.2917H18.0837"
      stroke="currentcolor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default UtilityStrokeNotificationMediumIcon;
